module.exports = __webpack_public_path__ + "static/media/37_A.9a81c4b1.png";